<template>
  <div class="hzc-price-index">
    <div class="back">当前位置：<span style="cursor: pointer" @click="back('/coke')">焦炭</span> > <span
        @click="back('/coke/twoPage/enterprise')" style="cursor: pointer">重点企业资讯</span> > 正文
    </div>
    <DetailTitle :title="endTime + '焦炭重点企业资讯'"></DetailTitle>
    <el-table
        :data="tableData"
        height="700"
        :header-cell-style="{background:'#f2f2f2',color:'#222'}"
        border
        style="width: 100%;margin-top: 20px;">
      <el-table-column
          type="index"
          label="序号"
          fixed
          width="50">
      </el-table-column>
      <el-table-column
          align="left"
          fixed
          prop="clientName"
          width="500px"
          label="客户">
      </el-table-column>
      <el-table-column
          align="center"
          prop="areaName"
          label="城市">
      </el-table-column>
      <el-table-column
          align="center"
          prop="sumCapacity"
          label="产能">
      </el-table-column>
      <el-table-column
          align="center"
          prop="workRatio"
          label="焦化开工率">
      </el-table-column>
      <el-table-column
          align="center"
          prop="tonProfit"
          label="吨盈利(元/吨)">
      </el-table-column>
      <el-table-column
          align="center"
          prop="tarStock"
          label="焦油库存(吨)">
      </el-table-column>
      <el-table-column
          align="center"
          prop="crudeBenzeneStock"
          label="粗苯库存(吨)">
      </el-table-column>
      <el-table-column
          align="center"
          prop="tarPrice"
          label="焦油价格(元/吨)">
      </el-table-column>
      <el-table-column
          align="center"
          prop="crudeBenzenePrice"
          label="粗苯价格(元/吨)">
      </el-table-column>
      <el-table-column
          align="center"
          prop="allCokeStock"
          label="焦炭库存">
      </el-table-column>
      <el-table-column
          align="center"
          label="煤炭库存">
        <el-table-column
            align="center"
            prop="coalStock"
            label="库存量">
        </el-table-column>
        <el-table-column
            align="center"
            prop="coalAvailableDays"
            label="可用天数">
        </el-table-column>
      </el-table-column>
      <el-table-column
          align="center"
          prop="coalBlendingPrice"
          label="配煤价">
      </el-table-column>
      <el-table-column
          align="center"
          prop="cokeTrend"
          label="焦炭价格走势预判">
        <template slot-scope="scope">
          <span>{{scope.row['cokeTrend'] === '1'? '涨':'跌'}}</span>
        </template>
      </el-table-column>
      <el-table-column
          align="center"
          label="运输方式">
        <el-table-column
            align="center"
            prop="fireVolume"
            label="火运量">
        </el-table-column>
        <el-table-column
            align="center"
            prop="freightVolume"
            label="汽运量">
        </el-table-column>
        <el-table-column
            align="center"
            prop="freightRate"
            label="运价">
        </el-table-column>
      </el-table-column>
      <el-table-column
          align="center"
          prop="remarks"
          width="500px"
          label="情况说明">
      </el-table-column>
      <el-table-column
          align="center"
          prop="createBy"
          label="业务员">
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import DetailTitle from '@/components/common/detatilTitle'
import {examineDetail} from '@/api/coke'

export default {
  components: {
    DetailTitle
  },
  data() {
    return {
      endTime: '',
      tableData: [],
    }
  },
  created() {
    this.endTime = this.$route.query.id;
    this.getDetail()
  },
  methods: {
    /**
     * 获取详情
     */
    getDetail() {
      examineDetail({collectionTime: this.endTime}).then(res => {
        this.tableData = res.data;
      })
    },
    back(url) {
      this.$router.push({path: url});
    },
  },
}
</script>

<style scoped lang="less">
.hzc-price-index {
  width: 1200px;
  margin: 0 auto;

  .slot-span {
    display: inline-block;
    text-align: center;
    line-height: 25px;
    width: 74px;
    height: 25px;
    background: #F2F2F2;
    border-radius: 4px;
    border: 1px solid #CCCCCC;
    cursor: pointer;
  }

  .slot-span:hover {
    background-color: #D3131A;
    border: 1px solid #D3131A;
    color: #fff;
  }

  .slot-hover {
    background-color: #D3131A;
    border: 1px solid #D3131A;
    color: #fff;
  }

  .echarts {
    margin-top: 24px;
    width:1140px;
    height: 351px;
    background: #FFFFFF;
    box-shadow: 0px 2px 10px 0px rgba(183, 183, 183, 0.5);
    padding: 30px;
  }
}
</style>
